import React from 'react';
import { BookOpen, ChevronDown } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';

export const GUIDES = {
  hr: { label: 'HR Manager guide', file: '/guides/staff_attendance_hr_manager_guide.pdf' },
  supervisor: { label: 'Supervisor guide', file: '/guides/staff_attendance_supervisor_guide.pdf' },
  staff: { label: 'Staff guide', file: '/guides/staff_attendance_staff_guide.pdf' },
};
const BTN = 'bg-transparent text-white border-white/30 hover:bg-white/10 hover:text-white';
const open = (k) => window.open(GUIDES[k].file, '_blank', 'noopener');

/** "User Guide" (English + Tamil PDF). One guide → direct link; several → menu. */
export const GuideMenu = ({ which = ['staff'], className = '' }) => {
  if (which.length === 1) {
    return (
      <Button variant="outline" size="sm" onClick={() => open(which[0])} className={`${BTN} ${className}`} data-testid={`guide-open-${which[0]}`}>
        <BookOpen className="w-4 h-4 mr-1" />User Guide
      </Button>
    );
  }
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className={`${BTN} ${className}`} data-testid="guide-menu-btn"><BookOpen className="w-4 h-4 mr-1" />User Guide<ChevronDown className="w-3.5 h-3.5 ml-1" /></Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {which.map((k) => <DropdownMenuItem key={k} onClick={() => open(k)} data-testid={`guide-open-${k}`}>{GUIDES[k].label} (English + தமிழ்)</DropdownMenuItem>)}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default GuideMenu;
